<template>
  <div class="firmware-page pa-6 pa-md-10">
    <v-card class="mb-4">
      <v-card-text class="pb-0">
        <div class="d-flex align-center flex-wrap" style="gap: 8px">
          <div class="text-h6">{{ $t('firmware.page.title') }}</div>
          <v-spacer />
          <!-- Les firmwares se créent et se règlent dans la fiche de leur constructeur -->
          <v-btn small outlined :to="{name: 'manufacturers'}"><v-icon small left>mdi-factory</v-icon>{{ $t('firmware.page.manufacturers') }}</v-btn>
        </div>
        <div class="text-caption text--secondary">{{ $t('firmware.page.explained') }}</div>
      </v-card-text>
      <v-tabs v-if="canReadFirmware" v-model="tab" show-arrows>
        <v-tab href="#updates">
          {{ $t('firmware.page.tabs.updates') }}
          <v-chip v-if="runningCampaigns" x-small color="primary" class="ml-2">{{ $t('firmware.page.running', {count: runningCampaigns}) }}</v-chip>
        </v-tab>
        <v-tab v-if="canReadDiagnostics" href="#diagnostics">{{ $t('firmware.page.tabs.diagnostics') }}</v-tab>
      </v-tabs>
    </v-card>

    <v-alert v-if="!canReadFirmware" type="warning" text dense>{{ $t('firmware.page.operator-only') }}</v-alert>
    <firmware-updates v-else-if="tab === 'updates'" @loaded="countRunning" />
    <firmware-diagnostics v-else-if="tab === 'diagnostics'" />
  </div>
</template>

<script>
import FirmwareRepository from "@repository/FirmwareRepository";
import FirmwareMixin from "@pages/Firmware/FirmwareMixin";
import FirmwareUpdates from "./FirmwareUpdates.vue";
import FirmwareDiagnostics from "./FirmwareDiagnostics.vue";

const TABS = ['updates', 'diagnostics']

/**
 * La rubrique Firmware : Mises à jour · Diagnostics. Les firmwares vivent dans la fiche de leur constructeur (bouton
 * Constructeurs) ; on met à jour depuis cette fiche, depuis celle d'un firmware ou depuis celle d'une borne.
 */
export default {
  components: {FirmwareUpdates, FirmwareDiagnostics},
  mixins: [FirmwareMixin],

  data() {
    return {runningCampaigns: 0}
  },

  computed: {
    canReadDiagnostics() {
      return this.isFirmwareOperator && this.hasFirmwarePermission('DIAGNOSTICS_REQUEST')
    },
    // L'onglet, gardé dans l'adresse : un lien mène droit à une mise à jour.
    tab: {
      get() {
        const tab = this.$route.query.tab
        if (tab === 'diagnostics' && !this.canReadDiagnostics) {
          return TABS[0]
        }
        return TABS.includes(tab) ? tab : TABS[0]
      },
      set(tab) {
        if (tab !== this.tab) {
          this.$router.replace({query: {tab}})
        }
      },
    },
  },

  mounted() {
    if (this.canReadFirmware) {
      FirmwareRepository.campaigns().then(this.countRunning).catch(() => {})
    }
  },

  methods: {
    countRunning(campaigns) {
      this.runningCampaigns = (campaigns || []).filter(campaign => ['scheduled', 'running', 'paused'].includes(campaign.status)).length
    },
  },
}
</script>
